const USER_ROLE = Object.freeze({
  manager: 'manager',
  receptionist: 'receptionist',
  noAccess: 'no_access',
});

export default USER_ROLE;
